module.exports = __webpack_public_path__ + "img/hero1.0144b61a.jpeg";